import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=0f021cde&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=js"
export * from "./ClientSearch.vue?vue&type=script&lang=js"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=0f021cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f021cde",
  null
  
)

export default component.exports